import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { PublicLayout } from 'src/layouts/setting/public-layout';

const IndexPage = lazy(() => import('src/pages/dashboard/index'));
const ContactPage = lazy(() => import('src/pages/dashboard/contact'));
const ProductDetailsPage = lazy(() => import('src/pages/inv/products/createProducts'));
const AboutPage = lazy(() => import('src/pages/dashboard/about'));
const PolicyPage = lazy(() => import('src/pages/dashboard/policy'));

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <PublicLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </PublicLayout>
    ),
    children: [
      {
        index: true,
        element: <IndexPage />
      },
      {
        path: 'contact',
        element: <ContactPage />
      },
      {
        path: 'createProduct',
        element: <ProductDetailsPage />
      }, {
        path: 'about',
        element: <AboutPage />
      }, {
        path: 'policy',
        element: <PolicyPage />
      },
    ],
  },

];
